module.exports = __webpack_public_path__ + "fonts/Ubuntu-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Ubuntu/Ubuntu-Regular.ttf
// module id = 3469
// module chunks = 0